<template>
    <div class="bg-white/25 h-px">
        <div
            class="block relative left-0 top-0 h-px bg-white"
            :style="{ width: `${progress * 100}%` }"
        />
    </div>
</template>

<script setup>
    import { ref } from 'vue';
    import { useSwiper } from 'swiper/vue';

    const swiper = useSwiper();
    const progress = ref(0);
    const time = ref(null);
    const running = ref(false);

    const updateProgress = () => {
        if (!swiper.value.autoplay.running || !running.value) {
            return;
        }

        const diff = (new Date().getTime() - time.value) / swiper.value.params.autoplay.delay;
        progress.value = Math.min(1, diff);

        requestAnimationFrame(updateProgress);
    };

    const initProgress = () => {
        progress.value = 0;
        time.value = new Date().getTime();
    };

    swiper.value.on('slideChangeTransitionStart', () => {
        initProgress();
        running.value = false;
    });

    swiper.value.on('slideChangeTransitionEnd', () => {
        initProgress();

        running.value = true;
        updateProgress();
    });

    swiper.value.on('init', () => {
        initProgress();

        running.value = true;
        updateProgress();
    });
</script>
